import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme
} from '@mui/material';

import React, { ReactNode } from 'react';



export type StyledTableProps = {
  rows: ReactNode | ReactNode[];
  headers: string[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: StyledTableProps) => {
  const theme = useTheme();
  return (
    <Box
      borderRadius='.75rem'
      paddingX='.875rem'
      bgcolor={theme.palette.customGray.light}
    >
      <TableContainer>
        <Table >
          <TableHead >
            <TableRow>
              {props.headers.map((node, i) => (
                <TableCell
                  key={`header-${i}`}
                  variant='head'

                >
                  {node}
                </TableCell>
              ))}

            </TableRow>
          </TableHead>
          <TableBody>
            {props.rows}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
